/// <reference types="./page_break.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../lustre/lustre/attribute.mjs";
import * as $html from "../../../lustre/lustre/element/html.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../../gleam.mjs";

export class PageBreak extends $CustomType {
  constructor(index, metadata) {
    super();
    this.index = index;
    this.metadata = metadata;
  }
}

export class Metadata extends $CustomType {
  constructor(kind) {
    super();
    this.kind = kind;
  }
}

export function to_html(page_break) {
  let _block;
  let $ = page_break.index;
  if ($ instanceof Some) {
    let i = $[0];
    _block = toList([$a.attribute("data-index", $int.to_string(i))]);
  } else {
    _block = toList([]);
  }
  let _pipe = _block;
  return $html.hr(_pipe);
}

function type_decoder() {
  return $decode.then$(
    $decode.string,
    (string) => {
      if (string === "page_break") {
        return $decode.success(undefined);
      } else {
        return $decode.failure(undefined, "page_break");
      }
    },
  );
}

function metadata_decoder() {
  let decoder$1 = $decode.optional($kind.decoder());
  return $decode.optional_field(
    "kind",
    new None(),
    decoder$1,
    (kind) => { return $decode.success(new Metadata(kind)); },
  );
}

export function encode(page_break) {
  return $json.object(
    toList([
      ["type", $json.string("page_break")],
      ["index", $json.nullable(page_break.index, $json.int)],
      ["html_tag", $json.string("")],
      ["metadata", $json.object(toList([]))],
    ]),
  );
}

function empty_metadata() {
  return new Metadata(new None());
}

export function decoder() {
  return $decode.field(
    "type",
    type_decoder(),
    (_) => {
      return $decode.field(
        "index",
        $decode.optional($decode.int),
        (index) => {
          return $decode.optional_field(
            "metadata",
            empty_metadata(),
            metadata_decoder(),
            (metadata) => {
              return $decode.success(new PageBreak(index, metadata));
            },
          );
        },
      );
    },
  );
}

export function from_html_string(html) {
  let _block;
  let _pipe = $string.trim(html);
  _block = $string.starts_with(_pipe, "<hr");
  let is_page_break = _block;
  return $bool.guard(
    !is_page_break,
    new Error(undefined),
    () => {
      let root = $html_parser.as_tree(html);
      let _block$1;
      let _pipe$1 = $html_parser.extract_attribute("data-index", root);
      let _pipe$2 = $option.map(
        _pipe$1,
        (i) => {
          let _pipe$2 = $int.parse(i);
          return $option.from_result(_pipe$2);
        },
      );
      _block$1 = $option.flatten(_pipe$2);
      let index = _block$1;
      return new Ok(new PageBreak(index, new Metadata(new $option.None())));
    },
  );
}
